var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"title":"已保存","btn-list":_vm.btnData}})}
var staticRenderFns = []

export { render, staticRenderFns }